export enum EnumInterfaceType {
    NotDefined = 0,
    HofApp = 1,
    WiegeApp = 2,
    SelbstverwiegungApp = 3,
    AuftragApp = 4,
    PortalShop = 5,
    Bewertung = 6,
    HofAppZwei = 7,
    Schnittstelle = 8,
    AVAL = 9,
    RLG = 10,
    GoPortal = 11,
    SAPWaage = 12,
    Lightcycle = 13,
    SAPXmlExport = 14,
    KRW = 15,
    CleverWaste = 16,

    TestDummy = 99
}